var productCardMarkup = `{{#products}}
			<div class="item product-block-wrapper">
				<div class="col-image">
					<a href="{{du}}" class="item-image" title="{{dt}}" tabindex="0">
						<img src="{{iu}}" alt="{{dt}}" />
					</a>
				</div>
				<div class="col-not-image">
					<div class="item-title item-name">
						<a href="{{du}}" class="item-title-wrap" title="{{dt}}" tabindex="0">
							<span>{{dt}}</span>
						</a>
					</div>
					<div class="item-title item-price">
						<span class="money">{{cu}}{{pr}}</span>
					</div>
					<div class="item-title item-remove">	
						<span id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
							Remove
						</span>
					</div>
					<div class="item-title item-add-to-cart">
						<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn btn btn--full btn-theme swym-button swym-button-1 swym-is-button swym-is-button">
							{{#isInCart}}Added to cart{{/isInCart}}
							{{^isInCart}}Add to cart{{/isInCart}}
						</button> 
					</div>
				</div>
				<div class="mobile-item-add-to-cart">
					<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn btn btn--full btn-theme swym-button swym-button-1 swym-is-button swym-is-button">
						{{#isInCart}}Added to cart{{/isInCart}}
						{{^isInCart}}Add to cart{{/isInCart}}
					</button>
				</div>
			</div>
		{{/products}}
	`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function wishlistItemCount(){
	window._swat.wishlistCount(
		function(r) {
			if(r==0){
				$(".wishlist-items-container").addClass("hide");
				$(".empty-wishlist-message").removeClass("hide");
			} else {
				$(".empty-wishlist-message").addClass("hide");
				$(".wishlist-items-container").removeClass("hide");
			}
		}
	);
  setTimeout(function() {
    window._swat.wishlistCount(
      function(r) {
        console.log(r);
        $(".swym-wishlist-count").text(r);
      }
    );
  },500);
}


function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		wishlistContentsContainer.innerHTML = productCardsMarkup;
		attachClickListeners();
	});
	wishlistItemCount();
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	var btnElm = e.currentTarget;
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		location.reload();
	}, function(e) {
		alert(e);
		btnElm.innerHTML = "Add to Cart";
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
					wishlistItemCount();
				});
			}
		});
	});
  
}

